import { Component, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageComponent } from '../page/page.component';
import { Application } from '@softline/application';
import { IconComponent, UiCorePipesModule } from '@softline/ui-core';
import { Router } from '@angular/router';

@Component({
  selector: 'soft-module-page',
  imports: [CommonModule, PageComponent, IconComponent, UiCorePipesModule],
  templateUrl: './module-page.component.html',
  styleUrl: './module-page.component.scss',
})
export class ModulePageComponent {
  readonly router = inject(Router);
  modules = input.required<Application[]>();

  async onClick(module: Application): Promise<void> {
    if (module?.type === 'link') {
      window.open(module?.href, '_blank');
    } else {
      await this.router.navigate([module.route], module.routeParams);
    }
  }

  isAppModule = (app: Application) => {
    return app?.type !== 'link';
  }
}
